import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LOGO_URL = "https://storage.readdy-site.link/project_files/66944f43-98f8-4b93-9b7b-b30b3c21b463/94004039-8de5-48e9-9540-2aa85385c229_bursaguide360.png?v=0efaf155294533f73de6ad4831ddc4e5";

const QR_ITEMS = [
  {
    numKey: "qr_item1_num",
    titleKey: "qr_item1_title",
    descKey: "qr_item1_desc",
    ctaKey: "qr_item1_cta",
    ctaHref: "https://extrempark.com.tr/bilet",
    icon: "ri-rocket-line",
    highlighted: true,
    bgImage: "https://public.readdy.ai/ai/img_res/0e0c35dc7a1e64c40d5084431334e677.jpg",
  },
  {
    numKey: "qr_item2_num",
    titleKey: "qr_item2_title",
    descKey: "qr_item2_desc",
    ctaKey: "qr_item2_cta",
    ctaHref: "https://maps.google.com/?q=Yesil+Cami+Bursa",
    icon: "ri-building-4-line",
    highlighted: false,
    bgImage: null,
  },
  {
    numKey: "qr_item3_num",
    titleKey: "qr_item3_title",
    descKey: "qr_item3_desc",
    ctaKey: "qr_item3_cta",
    ctaHref: "https://maps.google.com/?q=Kebapci+Iskender+Bursa",
    icon: "ri-restaurant-2-line",
    highlighted: false,
    bgImage: null,
  },
  {
    numKey: "qr_item4_num",
    titleKey: "qr_item4_title",
    descKey: "qr_item4_desc",
    ctaKey: "qr_item4_cta",
    ctaHref: "#",
    icon: "ri-flight-land-line",
    highlighted: false,
    bgImage: null,
  },
  {
    numKey: "qr_item5_num",
    titleKey: "qr_item5_title",
    descKey: "qr_item5_desc",
    ctaKey: "qr_item5_cta",
    ctaHref: "https://maps.google.com/?q=Cumalikizik+Bursa",
    icon: "ri-ancient-gate-line",
    highlighted: false,
    bgImage: null,
  },
];

export default function QRLanding() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isAr = i18n.language === "ar";

  useEffect(() => {
    document.documentElement.dir = isAr ? "rtl" : "ltr";
    window.scrollTo(0, 0);
  }, [isAr]);

  return (
    <div className="min-h-screen bg-[#f8fdf9]" dir={isAr ? "rtl" : "ltr"}>
      {/* Top Bar */}
      <div className="bg-[#1a3c2e] text-white px-5 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 flex items-center justify-center">
            <img src={LOGO_URL} alt="Bursa Guide 360" className="w-8 h-8 object-contain" />
          </div>
          <span className="font-bold text-sm">Bursa Guide 360</span>
        </div>
        <div className="flex items-center gap-2">
          {["tr", "en", "ar"].map((lang) => (
            <button
              key={lang}
              onClick={() => i18n.changeLanguage(lang)}
              className={`text-xs font-bold px-2 py-1 rounded-full cursor-pointer transition-all ${i18n.language === lang ? "bg-[#4a9c6f] text-white" : "text-white/60 hover:text-white"}`}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      {/* Hero */}
      <div className="bg-gradient-to-br from-[#1a3c2e] to-[#2d7a4f] text-white px-6 py-10 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 text-white/90 text-xs font-semibold px-3 py-1.5 rounded-full mb-4 uppercase tracking-wider">
          <i className="ri-map-pin-2-fill text-[#74c69d]"></i>
          {t("qr_badge")}
        </div>
        <h1 className="text-3xl md:text-4xl font-extrabold mb-1">{t("qr_title")}</h1>
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#74c69d]">{t("qr_title_accent")}</h2>
        <p className="text-white/75 text-sm mt-3 max-w-sm mx-auto leading-relaxed">{t("qr_desc")}</p>
      </div>

      {/* Items */}
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">
        {QR_ITEMS.map((item) => (
          <div
            key={item.numKey}
            className={`rounded-2xl overflow-hidden border transition-all ${item.highlighted ? "border-[#4a9c6f]/60 shadow-md" : "border-[#e0f0e8] bg-white"}`}
          >
            {item.highlighted && item.bgImage ? (
              // Featured Item with image
              <div className="relative min-h-48">
                <img src={item.bgImage} alt={t(item.titleKey)} className="absolute inset-0 w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>
                <div className="relative z-10 p-5 flex flex-col justify-end min-h-48">
                  <div className="inline-flex items-center gap-1.5 bg-[#4a9c6f] text-white text-xs font-black px-2.5 py-1 rounded-full mb-3 w-fit uppercase tracking-wider">
                    <i className={item.icon}></i>
                    #{t(item.numKey)}
                  </div>
                  <h3 className="font-extrabold text-white text-xl mb-1">{t(item.titleKey)}</h3>
                  <p className="text-white/80 text-sm leading-relaxed mb-4">{t(item.descKey)}</p>
                  <a
                    href={item.ctaHref}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="inline-flex items-center gap-2 bg-[#4a9c6f] hover:bg-[#3d8860] text-white font-bold px-5 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm w-fit"
                  >
                    <i className="ri-ticket-2-line"></i>
                    {t(item.ctaKey)}
                  </a>
                </div>
              </div>
            ) : (
              // Regular item
              <div className="p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#e6f7ef] rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-[#4a9c6f] text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-[#c8e6d5] text-xs font-black">#{t(item.numKey)}</span>
                    <h3 className="font-bold text-[#1a3c2e] text-base">{t(item.titleKey)}</h3>
                  </div>
                  <p className="text-[#6a8a7a] text-sm leading-relaxed mb-3">{t(item.descKey)}</p>
                  <a
                    href={item.ctaHref}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="inline-flex items-center gap-1.5 text-[#4a9c6f] hover:text-[#2d7a4f] font-semibold text-sm cursor-pointer transition-colors"
                  >
                    {t(item.ctaKey)}
                    <i className="ri-arrow-right-line text-xs"></i>
                  </a>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Back to main */}
      <div className="max-w-2xl mx-auto px-4 pb-10 text-center">
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 bg-[#1a3c2e] hover:bg-[#2d7a4f] text-white font-bold px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
        >
          <i className="ri-arrow-left-line"></i>
          {t("qr_back")}
        </button>
        <p className="text-[#9abaa8] text-xs mt-4">{t("qr_powered")}</p>
      </div>
    </div>
  );
}
